import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import PayoutReport from '../../payoutsReport';
import WithCommissionSplits from '../WithCommissionSplits';
import {
  getShopPayoutReportCsv,
  getShopPayoutReport,
  getBrandPayoutReport,
  getBrandPayoutReportCsv,
  getBarberPayoutReport,
  getBarberPayoutReportCsv,
} from '../../actions';
import * as authSelectors from '../../../../auth/selectors';
import fetchData from '../../hoc/fetchData';
import withTimezone from '../../../../auth/utils/withTimezone';
import { getPaymentFilters, getSelectedFilterSlugs, isGmeBrandView } from '../../selectors';
import { ChurnZeroService, RUN_COMMISSION_PAYOUT_REPORT } from '../../../../../modules/infra/observability/churnzero';
import config from '../../../../../config';

const mapStateToProps = (state) => ({
  shop: authSelectors.getActiveShopId(state),
  shopName: authSelectors.activeShopName(state),
  barber: authSelectors.getActiveBarberId(state),
  barberName: authSelectors.getActiveBarberName(state),
  commissionSplits: authSelectors.activeShopCommissionSplits(state),
  isSingleShopOtpBrand: authSelectors.isSingleShopOtpBrand(state),
  brandSingleShopId: authSelectors.getBrandSingleShopId(state),
  brandSingleShopName: authSelectors.getBrandSingleShopName(state),
  paymentFilter: getPaymentFilters(state),
  activeType: authSelectors.getActiveType(state),
  brandName: authSelectors.getActiveBrandName(state),
  brand: authSelectors.getActiveBrandId(state),
  exportReportDays: isGmeBrandView(state) ? 1 : config.exportReportDays,
});

const mapDispatchToProps = {
  getShopPayoutReport,
  getBarberPayoutReport,
  getBrandPayoutReport,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimezone,
  branch((props) => props.commissionSplits || props.isSingleShopOtpBrand, renderComponent(WithCommissionSplits)),
  withHandlers({
    getReport: (props) => (start, end) => {
      ChurnZeroService.track(RUN_COMMISSION_PAYOUT_REPORT);
      if (props.activeType === 'shop') {
        return props.getShopPayoutReport({
          shopId: props.shop,
          fromDate: start,
          toDate: end,
          paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
        });
      }

      if (props.activeType === 'barber') {
        return props.getBarberPayoutReport({
          barberId: props.barber,
          fromDate: start,
          toDate: end,
          paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
        });
      }

      if (props.isSingleShopOtpBrand) {
        return props.getShopPayoutReport({
          shopId: props.brandSingleShopId,
          fromDate: start,
          toDate: end,
          paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
        });
      }

      return props.getBrandPayoutReport({
        brandId: props.brand,
        fromDate: start,
        toDate: end,
        paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
      });
    },
    getCsv: (props) => (start, end) => {
      if (props.activeType === 'shop') {
        return getShopPayoutReportCsv({
          shopId: props.shop,
          name: props.shopName,
          fromDate: start,
          toDate: end,
          timezone: props.timezone,
          paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
        });
      }

      if (props.activeType === 'barber') {
        return getBarberPayoutReportCsv({
          barberId: props.barber,
          name: props.barberName,
          fromDate: start,
          toDate: end,
          timezone: props.timezone,
          paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
        });
      }

      if (props.isSingleShopOtpBrand) {
        return getShopPayoutReportCsv({
          name: props.brandSingleShopName,
          timezone: props.timezone,
          shopId: props.brandSingleShopId,
          fromDate: start,
          toDate: end,
          paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
        });
      }

      return getBrandPayoutReportCsv({
        brandId: props.brand,
        name: props.brandName,
        fromDate: start,
        toDate: end,
        timezone: props.timezone,
        paymentFilter: getSelectedFilterSlugs(props.paymentFilter),
      });
    },
  }),
  fetchData
);

export default enhance(PayoutReport);
